import { render, staticRenderFns } from "./TaskDataPointPopup.vue?vue&type=template&id=8b4babd6&scoped=true&"
import script from "./TaskDataPointPopup.vue?vue&type=script&lang=js&"
export * from "./TaskDataPointPopup.vue?vue&type=script&lang=js&"
import style0 from "./TaskDataPointPopup.vue?vue&type=style&index=0&id=8b4babd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4babd6",
  null
  
)

export default component.exports